import React from 'react'
import styled from 'styled-components'

const Card = styled.div`
  background: #f5f5f5;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 4px 5px 0 rgba(25, 34, 35, 0.09);
  padding: 1rem;
`
export default Card



// WEBPACK FOOTER //
// ./src/components/card.js